import demographics from './demographics/demographics.configuration';
import additional from './additional/additional.configuration';
import immigration from './immigration/immigration.configuration';

export const validations = { demographics, immigration, additional };
